import { Injectable } from '@angular/core';
import { DataService } from '../data.service'; 
import { Observable } from 'rxjs/Observable';
import { getBaseUrl } from '../../app.module';

@Injectable({
  providedIn: 'root'
})
export class StudyReportUploadService {

  private readonly studyReportImageUploadEndPoint: string =
    '/studyReportImageUpload/studyReportImageUpload/';

  constructor( private dataService: DataService) { }

  async studyReportImageUpload( studyReportId: number, image: File ): Promise<string> {

    return new Promise((resolve, reject) => {
      try {

        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = async () => {

          const base64Url =  <string>reader.result;
          const base64Image = base64Url.split('base64,')[1];

          const path = await this.dataService.post<string>(
            this.studyReportImageUploadEndPoint, {
              studyReportId,
              base64Image
            }).toPromise();

          resolve(`${ path }`);
        };
      } catch ( err ) {
        reject( err );
      }
    });

  }
}
